import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "titleDashboard" }
const _hoisted_3 = {
  class: "iconStatus",
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "25px",
  viewBox: "0 0 300.000000 300.000000"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  class: "iconStatus",
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "25px",
  viewBox: "0 0 300.000000 300.000000"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  class: "iconStatus",
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "25px",
  viewBox: "0 0 300.000000 300.000000"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  class: "iconStatus",
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "25px",
  viewBox: "0 0 300.000000 300.000000"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 2 }

import { Ref, ref, onMounted, computed, watch } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import GaugeComponent from '@/components/SmartLink/dashboard/GaugeComponent.vue';
import DialogComponent from '@/components/SmartLink/dialog/dialogComponent.vue';
import SingleCard from '@/components/SmartLink/topology/SingleCard.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { IMAGES_SVG } from '@/constants/images';
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 *********** VUETIFY ************
 *******************************/
import { useDisplay } from 'vuetify';
import router               from '@/router';

/********************************
 ********* INTERFACES ***********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables'
import { TOPOLOGYDATA, GENERAL_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';
import { SNR }     from '@/interfaces/SmartLink/KPI';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getCountStatusTopology, getOperabilityLastDayTopology } from '@/services/Smartlink/Topology';

/**
 * Cantidad de Filas visibles en la tabla por página
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'TopologyStatsView',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const { smAndDown } = useDisplay();

/********************************
 ************ ROUTER ************
 *******************************/
const rows      = ref(7);


/**
 * HEADER de la tabla de los equipo con estado OK y CAIDO
 */
const headersOKDOWN:Ref<HEADER[]> = ref([]); 

/**
 * HEADER de la tabla de los equipos con estado ALERTA Y ALARMA 
 */
const headersALEALA:Ref<HEADER[]> = ref([]);

/**
 * Regresa el modelo SVG del tipo de equipo
 * @param type Tipo de equipo
 */
function getIMGsvg(type:string) {
    let finalIMG = '';
    finalIMG = IMAGES_SVG[type.toLowerCase()];
    return finalIMG
}


/**
 * Regresa el ancho necesario para el gráfico
 * Si el parametro es 0, regresa 0px; si tiene algún valor, regresa 320px
 * @param count Cantidad de valores dentro del array de alertas/alarmas
 */
// const widthTimeLine = (count:number) => {
//     let cantidad = ''
//     count === 0 ? cantidad = '0px' : cantidad = '320px'
//     return cantidad
// }


/**
 * Lista de todos los equipos
 */
const countEquipStatus:Ref<TOPOLOGYDATA | undefined> = ref<TOPOLOGYDATA>(); 

/**
 * Captura la info de la API "getAllTopologyData"
 * lo ordena por nombre y de acuerdo al estado y su subtipo (distrution, access, client),
 * lo almacena en las variables correspondientes
 * - TODOS los valores se almacenan en las tablas correspondientes, en vez de hacer el match
 *  con los valores de alertas y alarmas que se obtenían de "getAlarmToDashBoard".
 * - Se hace un conteo de la cantidad de equipos en ok, alerta, alarma, caidos. Y ahora tendrán
 * el mismo valor, en el número y la tabla.
 */
async function getStatusData() {

    const allData = await getCountStatusTopology()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        countEquipStatus.value = allData.data
        matchALERTALARM();
    }

}

/**
 * Captura el objeto de la store (almacenado desde kpi-component)
 * y lo distribuye en "countEquipStatus", en cada una de las familias
 * "distribucion", "acceso", "cliente"
 * Los Valores son:
 * - La operabilidad TOTAL de los equipos para el componente GAUGE
 * - La operabilidad TOTAL de los equipos para el componente de la Linea de Tiempo
 * - Las alertas y alarmas de los equipos que se obtienen de la tabla EVENTOS Para el componente de alertas y alarmas
 * el cual se mostrará siempre y cuado hayan valores en ese array
 */
async function matchALERTALARM() {
    if(countEquipStatus.value) {
        let finalKPI = store.state.arrayTotalKPI;

        countEquipStatus.value.distri.totalGaug = finalKPI.distri.total;
        countEquipStatus.value.distri.totalAlar = finalKPI.distri.alarm;
        countEquipStatus.value.acceso.totalGaug = finalKPI.acceso.total;
        countEquipStatus.value.acceso.totalAlar = finalKPI.acceso.alarm;
        countEquipStatus.value.client.totalGaug = finalKPI.client.total;
        countEquipStatus.value.client.totalAlar = finalKPI.client.alarm;
    }
}

/**
 * Ip del equipo Seleccionado para el Dialogo
 */
const ipValue = ref('');

/**
 * Tipo del equipo Seleccionado para el Dialogo
 */
const typeValue = ref('');

/**
 * Nombre del equipo Seleccionado para el Dialogo
 */
const name = ref('');

/**
 * Marca del equipo Seleccionado para el Dialogo
 */
const itemMarca = ref('');

/**
 * Estado del equipo Seleccionado para el Dialogo
 */
const finalStatus = ref('');

/**
 * Valor del dialogo que se muestra al darle click a cualquier equipo en las tablas
 */
const dialog = ref(false);

/**
 * Captura toda la información del elemento seleccionado en la tabla
 * y se almacenan los valores de (ip, tipo, nombre, marca, estado) en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística
 * del equipo en cuestión
 * @param item La fila seleccionada en la tabla
 */
function showDialog (item: GENERAL_EQUIPAMENT) {
    ipValue.value = item.ip??'';
    typeValue.value  = item.tipo??'';
    name.value = item.name??'';        
    itemMarca.value = item.marca??'';
    finalStatus.value = item.status??'';
    dialog.value = true;
}

/**
 * Cierra el dialog abierto
 */
function closeDialog (){
    dialog.value    = false;
}


/**
 * Variable que almacena todos los valores de estado por equipo
 * para realizar el IEO de cada EQUIPO en las últimas 24Horas
 */
const getAllIEOByIP:Ref<SNR[]> = ref([]);

/**
 * Captura la operatividad de todos los equipos 
 * en las ultimas 24 horas, agrupados por IP
 * y lo almacena en la variable "getAllIEOByIP"
 */
async function getAllOperabilityLastDay () { 
    
    const allData = await getOperabilityLastDayTopology()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        getAllIEOByIP.value = allData.data
    }

}
/**
 * Recibe una IP y busca sus valores (Cantidad de ok, alertas, alarmas, caidos)
 * dentro de la variable getAllIEOByIP
 * Si no encuentra un match, regresa valor 0
 * @param ipSearch String de la IP a buscar
 */
function getStatusIEO (ipSearch:string) {
    let ieo = 0;
    let total = 1;
    const findObject:SNR|undefined = getAllIEOByIP.value.find((objeto:SNR) => objeto.ip === ipSearch)
    if(findObject) {
        total = (findObject.ok??0) + (findObject.alarm??0) + (findObject.alert??0) + (findObject.down??0);

        //si el total es igual a 0, se regresa un valor igual a 0, para evitar que se generen NaN
        if(total === 0 ) {
            ieo = 0
        }
        else{
            ieo = parseFloat(((findObject.ok??0)/total).toFixed(2))
        }
    }
    return ieo
}


/****************************
********* ANIMATION *********
****************************/

/**
 * Captura el valor de # (HASH) extraido de la URL (solo usado en topologyview)
 */
const hashRoute = computed(() => router.currentRoute.value.hash)

watch(hashRoute, (hash:string) => {
    scroll(hash)
})

/**
 * Realiza una animación de desplazamiento hacia la ID del elemento HTML
 * @param id #HASH extraido de la URL
 */
function scroll (id:string) {
    const finalID = id.slice(1)
    const element = document.getElementById(`${finalID}`);    
    if(element){
        element.scrollIntoView({ behavior: 'smooth' });
    }
}


onMounted( async () => {

    headersOKDOWN.value = FINAL_HEADERS_TABLE['principal'];
    headersALEALA.value = FINAL_HEADERS_TABLE['principal'];
    await getAllOperabilityLastDay();
    await getStatusData();   

    //Se realiza la animación del scroll 100ms después de cargar la info la primera vez 
    setTimeout(() => {
        scroll(hashRoute.value)
    }, 100);
})


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countEquipStatus.value, (item, i) => {
      return (_openBlock(), _createBlock(_component_v_sheet, {
        key: i,
        class: "defaultCard",
        color: "bgtopology"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            id: item.title,
            class: "headTopo mb-3 pt-4 ml-4"
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(`labels.${item.title}`)), 1)
          ], 8, _hoisted_1),
          _createVNode(_component_v_row, {
            class: "ma-0",
            justify: "center"
          }, {
            default: _withCtx(() => [
              (_unref(smAndDown))
                ? (_openBlock(), _createBlock(_component_v_sheet, {
                    key: 0,
                    color: "transparent",
                    width: "420",
                    style: {"align-content":"start"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GaugeComponent, {
                        recharge: false,
                        "array-items": item.totalGaug
                      }, null, 8, ["array-items"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(_component_v_sheet, {
                color: "transparent",
                style: _normalizeStyle(_unref(smAndDown) ? 'width: 100%' : 'width: calc(100% - 420px)')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    color: "transparent",
                    class: "cardTopologys"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        justify: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: _normalizeClass(_unref(smAndDown) ? 'pb-4 mb-4' : 'pa-0 px-4'),
                            cols: "12",
                            sm: "8",
                            md: "4",
                            lg: "4",
                            xl: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                bottomText: _unref(t)('labels.alert_pl'),
                                icon: 'mdi-exclamation-thick',
                                "color-icon": _unref(COLOR).red,
                                middleText: item.alert.cant.toString()
                              }, null, 8, ["bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          _createVNode(_component_v_col, {
                            class: "pa-0 px-4",
                            cols: "12",
                            sm: "12",
                            md: "8",
                            lg: "8",
                            xl: "9"
                          }, {
                            default: _withCtx(() => [
                              (item.alert.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    style: 'max-width: 400px !important;',
                                    class: "mb-5",
                                    modelValue: item.salert,
                                    "onUpdate:modelValue": ($event: any) => ((item.salert) = $event),
                                    label: _unref(t)('search'),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                : _createCommentVNode("", true),
                              (item.alert.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 1,
                                    "table-class-name": "customize-table",
                                    "show-index": "",
                                    headers: headersALEALA.value,
                                    items: item.alert.table,
                                    "rows-per-page": rows.value,
                                    "search-value": item.salert,
                                    onClickRow: showDialog
                                  }, {
                                    "item-icon": _withCtx((item) => [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                                        _createElementVNode("g", {
                                          innerHTML: getIMGsvg(item.tipo)
                                        }, null, 8, _hoisted_4)
                                      ]))
                                    ]),
                                    "item-ieo": _withCtx((item) => [
                                      _createElementVNode("span", null, _toDisplayString(getStatusIEO(item.host)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["headers", "items", "rows-per-page", "search-value"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.noalerts')), 1)
                                  ]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_sheet, {
                    color: "transparent",
                    class: "cardTopologys"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        justify: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: _normalizeClass(_unref(smAndDown) ? 'pb-4 mb-4' : 'pa-0 px-4'),
                            cols: "12",
                            sm: "8",
                            md: "4",
                            lg: "4",
                            xl: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                bottomText: _unref(t)('labels.alarm_pl'),
                                icon: 'mdi-lightbulb-on-outline',
                                "color-icon": _unref(COLOR).yellow,
                                middleText: item.alarm.cant.toString()
                              }, null, 8, ["bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          _createVNode(_component_v_col, {
                            class: "pa-0 px-4",
                            cols: "12",
                            sm: "12",
                            md: "8",
                            lg: "8",
                            xl: "9"
                          }, {
                            default: _withCtx(() => [
                              (item.alarm.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    style: 'max-width: 400px !important;',
                                    class: "mb-5",
                                    modelValue: item.salarm,
                                    "onUpdate:modelValue": ($event: any) => ((item.salarm) = $event),
                                    label: _unref(t)('search'),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                : _createCommentVNode("", true),
                              (item.alarm.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 1,
                                    "table-class-name": "customize-table",
                                    "show-index": "",
                                    headers: headersALEALA.value,
                                    items: item.alarm.table,
                                    "rows-per-page": rows.value,
                                    "search-value": item.salarm,
                                    onClickRow: showDialog
                                  }, {
                                    "item-icon": _withCtx((item) => [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                                        _createElementVNode("g", {
                                          innerHTML: getIMGsvg(item.tipo)
                                        }, null, 8, _hoisted_7)
                                      ]))
                                    ]),
                                    "item-ieo": _withCtx((item) => [
                                      _createElementVNode("span", null, _toDisplayString(getStatusIEO(item.host)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["headers", "items", "rows-per-page", "search-value"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.noalarms')), 1)
                                  ]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_sheet, {
                    color: "transparent",
                    class: "cardTopologys"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        justify: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: _normalizeClass(_unref(smAndDown) ? 'pb-4 mb-4' : 'pa-0 px-4'),
                            cols: "12",
                            sm: "8",
                            md: "4",
                            lg: "4",
                            xl: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                bottomText: _unref(t)('labels.ok_pl'),
                                icon: 'mdi-check',
                                "color-icon": _unref(COLOR).green,
                                middleText: item.ok.cant.toString()
                              }, null, 8, ["bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          _createVNode(_component_v_col, {
                            class: "pa-0 px-4",
                            cols: "12",
                            sm: "12",
                            md: "8",
                            lg: "8",
                            xl: "9"
                          }, {
                            default: _withCtx(() => [
                              (item.ok.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    style: 'max-width: 400px !important;',
                                    class: "mb-5",
                                    modelValue: item.sok,
                                    "onUpdate:modelValue": ($event: any) => ((item.sok) = $event),
                                    label: _unref(t)('search'),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                : _createCommentVNode("", true),
                              (item.ok.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 1,
                                    "table-class-name": "customize-table",
                                    "show-index": "",
                                    headers: headersOKDOWN.value,
                                    items: item.ok.table,
                                    "rows-per-page": 3,
                                    "search-value": item.sok,
                                    onClickRow: showDialog
                                  }, {
                                    "item-icon": _withCtx((item) => [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                                        _createElementVNode("g", {
                                          innerHTML: getIMGsvg(item.tipo)
                                        }, null, 8, _hoisted_10)
                                      ]))
                                    ]),
                                    "item-ieo": _withCtx((item) => [
                                      _createElementVNode("span", null, _toDisplayString(getStatusIEO(item.ip)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["headers", "items", "search-value"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_11, [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.nook')), 1)
                                  ]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_sheet, {
                    color: "transparent",
                    class: "cardTopologys"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        justify: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: _normalizeClass(_unref(smAndDown) ? 'pb-4 mb-4' : 'pa-0 px-4'),
                            cols: "12",
                            sm: "8",
                            md: "4",
                            lg: "4",
                            xl: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                bottomText: _unref(t)('labels.down_pl'),
                                icon: 'mdi-close',
                                "color-icon": _unref(COLOR).greyfake,
                                middleText: item.down.cant.toString()
                              }, null, 8, ["bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          _createVNode(_component_v_col, {
                            class: "pa-0 px-4",
                            cols: "12",
                            sm: "12",
                            md: "8",
                            lg: "8",
                            xl: "9"
                          }, {
                            default: _withCtx(() => [
                              (item.down.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    style: 'max-width: 400px !important;',
                                    class: "mb-5",
                                    modelValue: item.sdown,
                                    "onUpdate:modelValue": ($event: any) => ((item.sdown) = $event),
                                    label: _unref(t)('search'),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                : _createCommentVNode("", true),
                              (item.down.table.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 1,
                                    "table-class-name": "customize-table",
                                    "show-index": "",
                                    headers: headersOKDOWN.value,
                                    items: item.down.table,
                                    "rows-per-page": rows.value,
                                    "search-value": item.sdown,
                                    onClickRow: showDialog
                                  }, {
                                    "item-icon": _withCtx((item) => [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_12, [
                                        _createElementVNode("g", {
                                          innerHTML: getIMGsvg(item.tipo)
                                        }, null, 8, _hoisted_13)
                                      ]))
                                    ]),
                                    "item-ieo": _withCtx((item) => [
                                      _createElementVNode("span", null, _toDisplayString(getStatusIEO(item.ip)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["headers", "items", "rows-per-page", "search-value"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.nodown')), 1)
                                  ]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["style"]),
              (!_unref(smAndDown))
                ? (_openBlock(), _createBlock(_component_v_sheet, {
                    key: 1,
                    color: "transparent",
                    width: "420",
                    style: {"align-content":"start"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GaugeComponent, {
                        recharge: false,
                        "array-items": item.totalGaug
                      }, null, 8, ["array-items"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
      width: '85%'
    }, {
      default: _withCtx(() => [
        (dialog.value)
          ? (_openBlock(), _createBlock(DialogComponent, {
              key: 0,
              ip: ipValue.value,
              typeSel: typeValue.value,
              name: name.value,
              marca: itemMarca.value,
              status: finalStatus.value,
              onDialog: closeDialog
            }, null, 8, ["ip", "typeSel", "name", "marca", "status"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})